<template>
  <div>
    <Hero/>
    <Features/>
    <WeTrain/>
    <background-wrapper :src="routeNameKebab + `/fullscreen-image_explore-your-options_${$i18n.locale}`" ext="png">
      <div class="explore-your-options-wrapper">
        <h2 class="h1 text-center explore-your-options-title" v-html="$t(`products.Training.explore-your-options-pretitle`)" />
        <VueSlickCarousel class="explore-your-options-slider" :arrows="true" :autoplay="true">
          <div v-for="n in 9" :key="n">
            <div class="slide-image">
              <img :src="require(`@/assets/training/slider/slide_${n}_${$i18n.locale}.svg`)">
            </div>
          </div>
          <template #prevArrow>
            <div class="custom-arrow">
              <img src="@/assets/arrow-left.svg">
            </div>
          </template>
          <template #nextArrow>
            <div class="custom-arrow">
              <img src="@/assets/arrow-right.svg">
            </div>
          </template>
        </VueSlickCarousel>
        <div class="d-md-block d-none">
          <text-container class="explore-your-options" size="sm">
            <h2 class="h1" v-html="$t(`products.${$route.name}.explore-your-options.title`)"/>
            <p v-html="$t(`products.${$route.name}.explore-your-options.text`)"/>
            <b-btn class="mt-2" variant="primary" v-scroll-to="{ el: '#request-a-demo', offset: -70 }">
              {{$t(`get-training`)}}
            </b-btn>
          </text-container>
        </div>
      </div>
    </background-wrapper>
    <div class="d-md-none">
      <text-container class="explore-your-options" size="sm">
        <h2 class="h1" v-html="$t(`products.${$route.name}.explore-your-options.title`)"/>
        <p v-html="$t(`products.${$route.name}.explore-your-options.text`)"/>
        <b-btn class="mt-2" variant="primary" v-scroll-to="{ el: '#request-a-demo', offset: -70 }">
          {{$t(`get-training`)}}
        </b-btn>
      </text-container>
    </div>
    <h2 class="h1 text-center" v-html="$t(`products.Training.content-title`)" />
    <ContentWithImage class="explore-your-options-2" sectionName="test-their-knowledge" text-size="sm" justify-center title-smaller image-order="0" image-order-sm="0" :training="true" h2/>
    <ContentWithImage sectionName="electronic-certificate" text-size="sm" justify-center title-smaller image-order="1" image-order-sm="0" :training="true" h2/>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_training'" ext="png">
      <text-container class="training" size="lg" align-center justify-center>
        <h2 class="h1" v-html="$t(`products.${$route.name}.training.title`)"/>
        <p class="h-sub" v-html="$t(`products.${$route.name}.training.text`)"/>
        <b-btn class="mt-2" variant="primary" v-scroll-to="{ el: '#request-a-demo', offset: -70 }">
          {{$t(`request-demo`)}}
        </b-btn>
      </text-container>
    </background-wrapper>
    <RequestDemo style="padding-top: 65px"/>
    <Tools/>
    <LetsGet/>
  </div>
</template>

<script>
import { Hero, Tools, LetsGet, Features, ContentWithImage, RequestDemo, WeTrain } from '@/components/ui/products'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'Training',
  components: { Hero, Tools, LetsGet, Features, ContentWithImage, RequestDemo, VueSlickCarousel, WeTrain },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  }
}
</script>

<style lang="sass">
.explore-your-options-2
  img
    width: 80%!important

.request-demo-wrapper
  +media-breakpoint-down(sm)
    .background-wrapper__image
      display: none!important

    .request-a-demo
      margin: 100px 0!important
</style>

<style lang="sass" scoped>
.training
  padding-top: 20px
  padding-bottom: 460px
  @media screen and (min-width: 2000px)
    padding-top: calc((100vw - 2000px)/8 + 20px)
    padding-bottom: calc((100vw - 2000px)/4 + 460px)
  +media-breakpoint-down(sm)
    padding-bottom: 300px

.explore-your-options
  .d-md-none &
    padding: 100px 45px 150px 45px

  &-wrapper
    margin-bottom: 100px
    padding: 180px 0 200px
    +media-breakpoint-down(md)
      padding: 120px 0 200px
    +media-breakpoint-down(sm)
      padding: 90px 0 510px
    +media-breakpoint-down(xs)
      padding: 90px 0 405px

  &-title
    +media-breakpoint-down(xs)
      min-height: 120px

  &-slider
    margin: 200px auto 160px
    max-width: 540px
    width: 100%
    @media screen and (min-width: 2000px)
      margin-top: calc((100vw - 2000px)/6 + 200px)
      margin-bottom: calc((100vw - 2000px)/6 + 160px)
    +media-breakpoint-down(sm)
      margin: 180px auto 0
    +media-breakpoint-down(xs)
      max-width: 240px
      margin: 140px auto 0

.custom-arrow
  color: $dark
  font-size: 14px
  height: 29px
  &:before
    content: none

.slide-image
  display: flex
  justify-content: center
  align-items: center
  padding-top: 40px

  img
    max-width: 100%
</style>



// WEBPACK FOOTER //
// src/components/products/Training/Training.vue